import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { LegislationGroup, LegislationRecipient, LegislationRecipientGroup, LegislationRecipientVM, LEGISLATION_RECIPIENTS_COLUMNS } from 'app/legislation/legislation-items/legislation';
import { DialogsService } from 'app/_services/dialogs/dialogs.service';
import { LegislationService } from 'app/_services/legislation.service';
import { NotificationService } from 'app/_services/notification.service';
import { AddEditRecipientDialogComponent } from '../add-edit-recipient-dialog/add-edit-recipient-dialog.component';

@Component({
    selector: 'app-email-recipients',
    templateUrl: './email-recipients.component.html',
    styleUrls: ['../../../shared/table-defaults.scss', '../../legislation.component.scss', './email-recipients.component.scss'],
})
export class LegislationRecipientsComponent implements OnInit {
    isLoading = true;
    recipients: LegislationRecipientVM[];
    groups: LegislationGroup[];
    recipientGroups: LegislationRecipientGroup[];
    recipientNames: string[];
    dataSource: MatTableDataSource<LegislationRecipientVM>;
    
    recipientsColumns = LEGISLATION_RECIPIENTS_COLUMNS;
    columnsToDisplay = [ ...LEGISLATION_RECIPIENTS_COLUMNS, 'actions'];

    @ViewChild(MatTable) table: MatTable<LegislationRecipientVM>;

    constructor(
        public dialog: MatDialog,
        private dialogService: DialogsService,
        private legislationService: LegislationService,
        private notificationService: NotificationService
    ) {}

    ngOnInit(): void {
        const self = this;

        self.legislationService.getLegislationGroups().subscribe((groups) => {
            self.groups = groups;
        });

        self.legislationService.getLegislationRecipientGroups().subscribe((recipientGroups) => {
            self.recipientGroups = recipientGroups;
            self.isLoading = false;
        });
        
        self.legislationService.getLegislationRecipients().subscribe((recipients) => {
            self.recipients = recipients;
            self.loadDatasource(self.recipients);

            // Create list of email recipient names to pass into dialog for name validation.
            self.recipientNames = self.recipients.map((recipient) => recipient.name);
        });
    }

    trackBy(_index: number, recipient: LegislationRecipientVM) {
        return recipient.recipientId;
    }

    loadDatasource(data: LegislationRecipientVM[]): void {
        this.dataSource = null;
        this.dataSource = new MatTableDataSource(data);
    }

    applyFilter(searchTerms: any): void {
        this.dataSource.filter = searchTerms;

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    clearFilter(): void {
        this.dataSource.filter = '';

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    openLegislationRecipientDialog(recipient: LegislationRecipient, recipientNames: string[], title: string): MatDialogRef<AddEditRecipientDialogComponent> {
        const config: MatDialogConfig = {
            // disableClose: true,
            width: '450px',
            panelClass: 'edit-legislation-recipient',
            data: { recipient, recipientNames, title },
        };

        return this.dialog.open(AddEditRecipientDialogComponent, config);
    }

    addRecipient(): void {
        const self = this;
        const recipients = self.recipients;
        const recipientNames = self.recipientNames;
        const title = 'Add Recipient';
        const recipient = new LegislationRecipient();

        const dialogResult = self.openLegislationRecipientDialog(recipient, recipientNames, title);

        dialogResult.afterClosed().subscribe((result: LegislationRecipient) => {
            if (!result) {
                return;
            }

            self.legislationService.createLegislationRecipient(result).subscribe((res: LegislationRecipient) => {
                self.legislationService.getLegislationRecipientVMById(res.recipientId).subscribe((newRecipient: LegislationRecipientVM) => {
                    recipients.push(newRecipient);
                    self.table.renderRows();

                    // self.loadDatasource(recipients);
                    // self.setSortAndPagination();
                    self.notificationService.showSuccess(`New Legislation Recipient has been added.`);
                });
            });
        });
    }

    editRecipient(recipient: LegislationRecipientVM): void {
        const self = this;
        const recipients = this.recipients;
        const recipientNames = self.recipientNames;
        const title = `Edit Recipient - ${recipient.name}`;

        this.legislationService.getLegislationRecipientById(recipient.recipientId).subscribe((updatedRecipient) => {
            if (!updatedRecipient) {
                this.notificationService.showError(`ERROR: Legislation Recipient with id ${recipient.recipientId} could not be found.`);
                return;
            }

            const dialogResult = self.openLegislationRecipientDialog(updatedRecipient, recipientNames, title);

            dialogResult.afterClosed().subscribe((result: LegislationRecipient) => {
                if (!result) {
                    return;
                }

                self.legislationService.updateLegislationRecipient(result.recipientId, result).subscribe((res: LegislationRecipient) => {
                    recipient.recipientId = res.recipientId;
                    recipient.name = res.name;
                    recipient.email = res.email;
                });

                self.loadDatasource(recipients);
                self.notificationService.showSuccess(`Legislation Recipient has been updated.`);
            });
        });
    }

    deleteRecipient(recipient: LegislationRecipientVM): void {
        const self = this;
        const dialogResult$ = self.dialogService.OpenConfirmationDialog({
            TitleText: 'Delete Email Recipient',
            MessageText: 'Are you sure you want to remove this recipient from the list of Legislative Recipients?',
            OKText: 'Yes, remove recipient',
            CancelText: 'No',
        });

        dialogResult$.subscribe((result) => {
            if (!result) {
                return;
            }

            const index = self.dataSource.data.indexOf(recipient, 0);

            if (index > -1) {
                self.dataSource.data.splice(index, 1);
            }

            self.legislationService.deleteLegislationRecipient(recipient.recipientId).subscribe();

            self.table.renderRows();
            self.notificationService.showSuccess(`Legislation Recipient have been removed.`);
        });
    }
}
